const surveyStatuses = {
  getSurveyStatusColor(survey) {
    if (survey.isComplete) {
      return "lighttext";
    } else if (survey.liveInstancesCount > 0) {
      return "performance";
    } else if (survey.sentInstancesCount > 0) {
      return "success";
    } else if (survey.scheduledInstancesCount > 0) {
      return "primary";
    }
    return "info";
  },
  getSurveyStatusText(survey) {
    if (survey.isComplete) {
      return "Archived";
    } else if (survey.liveInstancesCount > 0) {
      return "Live";
    } else if (survey.sentInstancesCount > 0) {
      return "Sent";
    } else if (survey.scheduledInstancesCount > 0) {
      return "Scheduled";
    }
    return "Ready";
  },
  isSurveyStatusDark(survey) {
    return !survey.isComplete && survey.liveInstancesCount > 0;
  },
  getSurveyStatusIcon(survey) {
    if (survey.isComplete) {
      return "check_circle_outline";
    } else if (survey.sentInstancesCount > 0) {
      return "restore";
    } else if (survey.scheduledInstancesCount > 0) {
      return "query_builder";
    }
    return "";
  }
};

export default { methods: surveyStatuses };
